/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ASSET_EXPENSES_SUCCESS,
  GET_ASSET_EXPENSES_FAILURE,

  // GET_ASSET_MONTHWISE_EXPENSES,
  GET_ASSET_MONTHWISE_EXPENSES_FAILURE,
  GET_ASSET_MONTHWISE_EXPENSES_SUCCESS,
  GET_MONTHLY_GRAPH_SUCCESS,
  GET_MONTHLY_GRAPH_FAILURE,
  GET_YEARLY_GRAPH_SUCCESS,
  GET_YEARLY_GRAPH_FAILURE,
  GET_CASHFLOW_GRAPH,
  GET_CASHFLOW_GRAPH_SUCCESS,
  GET_CASHFLOW_GRAPH_FAILURE,
  RESET_CASHFLOW_GRAPH
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  expenses: [],
  monthwiseExpenses: {},
  monthlyGraph: {},
  yearlyGraph: {},
  cashFlowActual: [],
  cashFlowProjected: [],
  cashflow: {
    data: null,
    state: "INIT",
    error: null
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_EXPENSES_SUCCESS:
      return {
        ...state,
        getAssetExpensesSuccess: true,
        getAssetMonthwiseExpensesSuccess: null,
        expenses: action.payload.expenses
      };
    case GET_ASSET_EXPENSES_FAILURE:
      return {
        ...state,
        getAssetExpensesSuccess: false,
        getAssetMonthwiseExpensesSuccess: null,
        expenses: state.expenses
      };
    case GET_ASSET_MONTHWISE_EXPENSES_SUCCESS:
      return {
        ...state,
        getAssetMonthwiseExpensesSuccess: true,
        getAssetExpensesSuccess: null,
        monthwiseExpenses: action.payload.monthwiseExpenses
      };
    case GET_ASSET_MONTHWISE_EXPENSES_FAILURE:
      return {
        ...state,
        getAssetExpensesSuccess: null,
        getAssetMonthwiseExpensesSuccess: false,
        monthwiseExpenses: state.monthwiseExpenses
      };
    //------
    case GET_MONTHLY_GRAPH_SUCCESS:
      return {
        ...state,
        getMonthlyGraphSuccess: true,
        monthlyGraph: action.payload.monthlyGraph
      };
    case GET_MONTHLY_GRAPH_FAILURE:
      return {
        ...state,
        getMonthlyGraphSuccess: false,
        monthlyGraph: state.monthlyGraph
      };
    case GET_YEARLY_GRAPH_SUCCESS:
      return {
        ...state,
        getYearlyGraphSuccess: true,
        yearlyGraph: action.payload.yearlyGraph
      };
    case GET_YEARLY_GRAPH_FAILURE:
      return {
        ...state,
        getYearlyGraphSuccess: false,
        yearlyGraph: state.yearlyGraph
      };

    case GET_CASHFLOW_GRAPH:
      return setLoadingState(state, "cashflow");

    case GET_CASHFLOW_GRAPH_SUCCESS:
      return setSuccessResponse(state, action, "cashflow");

    case GET_CASHFLOW_GRAPH_FAILURE:
      return setErrorResponse(state, action.err, "cashflow");

    case RESET_CASHFLOW_GRAPH:
      return {};
    default:
      return state;
  }
}
